module.exports = __webpack_public_path__ + "img/complete.014a466e.svg";